const rankingItems = [
  { rank: 1, title: '斗破苍穹', tag: '玄幻', hot: '9.8', change: 'up', desc: '萧炎踏上斗气大陆巅峰之路' },
  { rank: 2, title: '一人之下', tag: '奇幻', hot: '9.7', change: 'up', desc: '异人世界的精彩冒险故事' },
  { rank: 3, title: '镇魂街', tag: '热血', hot: '9.6', change: 'same', desc: '守护灵与寄灵人的羁绊传奇' },
  { rank: 4, title: '狐妖小红娘', tag: '恋爱', hot: '9.5', change: 'up', desc: '前世今生的唯美仙侠爱恋' },
  { rank: 5, title: '完美世界', tag: '玄幻', hot: '9.4', change: 'down', desc: '石昊纵横大荒的少年传奇' },
  { rank: 6, title: '星骸骑士', tag: '科幻', hot: '9.3', change: 'up', desc: '星际战场上的机甲热血对决' },
  { rank: 7, title: '大王饶命', tag: '搞笑', hot: '9.2', change: 'up', desc: '灵气复苏时代的爆笑日常' },
];

const changeIcon = (c: string) => {
  if (c === 'up') return <i className="ri-arrow-up-fill text-accent-500 text-xs"></i>;
  if (c === 'down') return <i className="ri-arrow-down-fill text-foreground-400 text-xs"></i>;
  return <i className="ri-subtract-line text-foreground-400 text-xs"></i>;
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          人气排行
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          本周最受欢迎的免费漫画人气榜单
        </p>
        <div className="max-w-[900px] mx-auto bg-background-50 rounded-2xl overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 p-4 md:p-5 hover:bg-background-100/70 transition-colors cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div
                className={`w-9 h-9 rounded-lg flex items-center justify-center font-heading text-sm shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading text-sm md:text-base text-foreground-900">
                    {item.title}
                  </h3>
                  <span className="px-1.5 py-0.5 rounded text-[10px] bg-secondary-100 text-secondary-700 font-medium">
                    {item.tag}
                  </span>
                </div>
                <p className="text-foreground-500 text-xs truncate">{item.desc}</p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-xs text-foreground-400">{changeIcon(item.change)}</span>
                <span className="font-heading text-sm text-primary-600 w-10 text-right">
                  {item.hot}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}